import React from 'react'
import { CGE } from '../../../../common/components/CGE'
import ElectrodependentContextProvider, { ACTIONS, ElectrodependentContext } from '../../context/ElectrodependentContextProvider'
import FormsElectrodependent from '../FormsElectrodependent'
import SeguimientoSolicitud from '../SeguimientoSolicitud';
import RenovacionSolicitud from '../RenovacionSolicitud';
import BajaSolicitud from '../BajaSolicitud';
import CambioDomicilio from '../CambioDomicilio';
import Loading from "../../../../common/components/Loading";
import { decode_utf8, isRutValid, beforeMaskedValueChangeRut } from '../../../../common/utils/utilsFunc';
import WebContentResponseForms from '../WebContentResponseForms';
import AlertModal from '../../../../common/components/AlertModal';
import { useModal } from "@clayui/modal";



function FormsElectrodependentController({ props }) {
  const [state, dispatch] = React.useContext(ElectrodependentContext)
  const [idClient, setIdClient] = React.useState('')
  const [rutPatient, setRutPatient] = React.useState('')
  const [idRegion, setIdRegion] = React.useState('')
  const [estado, setEstado] = React.useState('')
  const [webContentResponse, setwebContentResponse] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [resetForm, setResetForm] = React.useState(false)
  const [error, setError] = React.useState(false)
  const [errorMsg, setErrorMsg] = React.useState(false)
  const [detailClientJson, setDetailClientJson] = React.useState([])
  const [detailSolcitudJson, setDetailSolcitudJson] = React.useState([])
  const [fechaIngresoSolicitud, setFechaIngresoSolicitud] = React.useState('')
  const [nroSolicitud, setNroSolicitud] = React.useState('')
  const [equiposED, setEquiposED] = React.useState([])
  const [jsonForm, setJsonForm] = React.useState(null)
  const [jsonFormRe, setJsonFormRe] = React.useState(null)
  const [jsonFormBa, setJsonFormBa] = React.useState(null)
  const [jsonFormCd, setJsonFormCd] = React.useState(null)
  const [currentPage, setCurrentPage] = React.useState("seguimientoSolicitud")
  const [tabsVisible, setTabsVisible] = React.useState([]);
  const [values, setValues] = React.useState({})
  const [inputValidate, setInputValidate] = React.useState({
    empty: {},
    validated: {},
    msg: {}
  });
  const [optionsComuna, setOptionsComuna] = React.useState([{
    label: "Selecione una opción",
    value: 0
  }])
  const [optionsRegion, setOptionsRegion] = React.useState([{
    label: "Selecione una opción",
    value: 0
  }])
  const [optionsComunaRegion, setOptionsComunaRegion] = React.useState([{
    label: "Selecione una opción",
    value: 0
  }])
  const [optionsTypeEquipments, setOptionsTypeEquipments] = React.useState([{
    label: "Selecione una opción",
    value: ""
  }])
  const [visibleModal, setVisibleModal] = React.useState(false);
  const [visibleModal2, setVisibleModal2] = React.useState(false);
  const { observer, onClose } = useModal({
    onClose: () => {
      setVisibleModal(false);
      setVisibleModal2(false)
      setResetForm(true);
    }
  });
  let propsLabelInfoContent = {
    "setVisibleModal": setVisibleModal2,
    "observer": observer,
    "onClose": onClose,
    "visibleModal": visibleModal2,
    "titleModal": "Información",
    "status": "info",
    "content": state?.webContentTextInfo
  }

  function handleClickButtonClient() {
    handleClearTabs();
    if (values.idClient && values.rutPatient) {

      if (!isRutValid(values.rutPatient)) {
        const errors = {
          empty: { ...inputValidate.empty },
          validated: { ...inputValidate.validated },
          msg: { ...inputValidate.msg }
        };
        errors.validated.rutPatient = true;
        errors.msg.rutPatient = "Debes ingresar un RUT del paciente válido.";
        setInputValidate(errors);
        props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
      } else {
        setLoading(true)
        setIdClient(values.idClient)
        setRutPatient(values.rutPatient)
        try {
          setTabs(estado);
          setLoading(false)
        } catch (error) {
          console.error("Error fetching solicitud status:", error);
          setLoading(false)
          props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        } finally {
          setLoading(false);
        }
      }
    } else {
      const errors = {
        empty: { ...inputValidate.empty },
        validated: { ...inputValidate.validated },
        msg: { ...inputValidate.msg }
      };
      if (!values.idClient) {
        errors.empty.idClient = true;
        errors.msg.idClient = "Debe ingresar un Nro de Cliente";
      }
      if (!values.rutPatient) {
        errors.empty.rutPatient = true;
        errors.msg.rutPatient = "Debes ingresar el RUT del paciente";
      }
      setInputValidate(errors);
      props.setGlobalAlert("Complete todos los campos obligatorios.", "warning");
    }
  }
  const setTabs = (estado) => {
    switch (estado) {
      case "Nueva solicitud":
        setTabsVisible(["ingresoSolicitud"]);
        setCurrentPage("ingresoSolicitud");
        break;
      case "En proceso":
        setTabsVisible(["seguimientoSolicitud"]);
        setCurrentPage("seguimientoSolicitud");
        break;
      case "Aprobada":
        setTabsVisible(["seguimientoSolicitud", "renovacionSolicitud", "bajaSolicitud", "cambioDomicilio"]);
        setCurrentPage("seguimientoSolicitud");
        break;
      case "Rechazado":
        setTabsVisible(["seguimientoSolicitud", "renovacionSolicitud", "bajaSolicitud", "cambioDomicilio"]);
        setCurrentPage("seguimientoSolicitud");
        break;
      case "Resuelto":
        setTabsVisible(["seguimientoSolicitud", "ingresoSolicitud"]);
        setCurrentPage("seguimientoSolicitud");
        break;
      default:
        handleClearTabs();
    }
  };
  const handleClearTabs = () => {
    console.log("Antes de limpiar:", tabsVisible);
    setTabsVisible([]);
    setCurrentPage("");
    console.log("Después de limpiar:", tabsVisible);
  };
  React.useEffect(() => {
    setLoading(true);
    dispatch({
      payload: true,
      type: ACTIONS.SET_LOAD_PAGE,
    });
  }, []);

  React.useEffect(() => {
    if (idClient) {
      setLoading(true)
      dispatch({
        type: ACTIONS.SET_IDCLIENT,
        payload: idClient
      })
      setIdClient('')
    }
  }, [idClient])

  React.useEffect(() => {
    if (rutPatient) {
      setLoading(true)
      dispatch({
        type: ACTIONS.SET_RUT,
        payload: rutPatient
      })
      setRutPatient('')
    }
  }, [rutPatient])

  React.useEffect(() => {
    if (jsonForm) {
      setLoading(true)
      dispatch({
        type: ACTIONS.SET_JSON_FORMS,
        payload: jsonForm
      })
    }
  }, [jsonForm])

  React.useEffect(() => {
    if (jsonFormBa) {
      setLoading(true)
      dispatch({
        type: ACTIONS.SET_JSON_FORMSBA,
        payload: jsonFormBa
      })
    }
  }, [jsonFormBa])

  React.useEffect(() => {
    if (jsonFormCd) {
      setLoading(true)
      dispatch({
        type: ACTIONS.SET_JSON_FORMSCD,
        payload: jsonFormCd
      })
    }
  }, [jsonFormCd])

  React.useEffect(() => {
    if (jsonFormRe) {
      setLoading(true)
      dispatch({
        type: ACTIONS.SET_JSON_FORMSRE,
        payload: jsonFormRe
      })
    }
  }, [jsonFormRe])

  React.useEffect(() => {
    if (state.responseForms) {
      setLoading(false)
      if (state.responseForms.data?.code === 0 || state.responseForms.data?.code) {
        if (state.responseForms.data?.code === 0) {
          setwebContentResponse(state.responseForms.data?.message)
          setVisibleModal(true)
        } else {
          props.setGlobalAlert(state.responseForms.data?.message ? state.responseForms.data?.message : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
          setwebContentResponse('');
        }

      } else if (state.responseForms.status === 500) {
        props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        setwebContentResponse('');


      } else {
        props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        setwebContentResponse('');
      }
    }
  }, [state.responseForms])

  React.useEffect(() => {
    if (state.responseFormsRe) {
      setLoading(false)
      if (state.responseFormsRe.data?.code === 0 || state.responseFormsRe.data?.code) {
        if (state.responseFormsRe.data?.code === 0) {
          setwebContentResponse(state.responseFormsRe.data?.message)
          setVisibleModal(true)
        } else {
          props.setGlobalAlert(state.responseFormsRe.data?.message ? state.responseFormsRe.data?.message : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
          setwebContentResponse('');
        }

      } else if (state.responseFormsRe.status === 500) {
        props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        setwebContentResponse('');


      } else {
        props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        setwebContentResponse('');
      }
    }
  }, [state.responseFormsRe])

  React.useEffect(() => {
    if (state.responseFormsBa) {
      setLoading(false)
      if (state.responseFormsBa.data?.code === 0 || state.responseFormsBa.data?.code) {
        if (state.responseFormsBa.data?.code === 0) {
          setwebContentResponse(state.responseFormsBa.data?.message)
          setVisibleModal(true)
        } else {
          props.setGlobalAlert(state.responseFormsBa.data?.message ? state.responseFormsBa.data?.message : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
          setwebContentResponse('');
        }

      } else if (state.responseFormsBa.status === 500) {
        props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        setwebContentResponse('');


      } else {
        props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        setwebContentResponse('');
      }
    }
  }, [state.responseFormsBa])

  React.useEffect(() => {
    if (state.responseFormsCd) {
      setLoading(false)
      if (state.responseFormsCd.data?.code === 0 || state.responseFormsCd.data?.code) {
        if (state.responseFormsCd.data?.code === 0) {
          setwebContentResponse(state.responseFormsCd.data?.message)
          setVisibleModal(true)
        } else {
          props.setGlobalAlert(state.responseFormsCd.data?.message ? state.responseFormsCd.data?.message : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
          setwebContentResponse('');
        }

      } else if (state.responseFormsCd.status === 500) {
        props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        setwebContentResponse('');


      } else {
        props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        setwebContentResponse('');
      }
    }
  }, [state.responseFormsCd])


  React.useEffect(() => {
    if (state.detailClient) {
      setLoading(false)
      if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN || state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
        if (state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO.RETURN === 0) {
          setDetailClientJson(state.detailClient?.ConsultarDetalleCtaCtoResponse?.ITEM)
        } else {
          setDetailClientJson([])
          props.setGlobalAlert(state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN ? state.detailClient?.ConsultarDetalleCtaCtoResponse?.RETORNO?.TEXTO_RETURN : decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
        }
      } else {
        setDetailClientJson([])
        props.setGlobalAlert(decode_utf8(props.text_fetch_error), "warning", true, "Advertencia");
      }
    }
  }, [state.detailClient])

  React.useEffect(() => {
    if (state.solicitudED?.code === 0) {
      setLoading(true)
      console.log("solicitudED: " + state.solicitudED);
      setDetailSolcitudJson(state.solicitudED.response);
      const estadoSolicitud = state?.solicitudED?.message || "";
      setEstado(estadoSolicitud);
      setFechaIngresoSolicitud(state?.solicitudED?.fechaSolicitud || "");
      setNroSolicitud(state?.solicitudED?.response?.nroSolicitud || "");
      setTabs(estadoSolicitud);
      setLoading(false)
    }

  }, [state.solicitudED]);

  React.useEffect(() => {
    if (state.equipos) {
      setEquiposED(state.equipos);
    }
  }, [state.equipos]);

  React.useEffect(() => {
    if (idRegion) {
      setLoading(true)
      dispatch({
        type: ACTIONS.SET_ID_REGION,
        payload: idRegion
      })
    }
  }, [idRegion])

  React.useEffect(() => {
    if (state.allRegion) {
      setLoading(false);
      if (state.allRegion.code === 0) {
        let regions = [];
        state.allRegion?.regions.forEach((item) => {
          regions.push({ label: item.nomeRegion, value: item.regionId })
        });
        setOptionsRegion([...optionsRegion, ...regions])
      } else {
        setError(true);
        state.allRegion?.message ? setErrorMsg(state.allRegion?.message) : setErrorMsg(decode_utf8(props.text_fetch_error))
      }
    }

  }, [state.allRegion])

  React.useEffect(() => {
    if (state.comunaRegion) {
      setLoading(false);
      if (state.comunaRegion.code === 0) {
        let comunas = [];
        state.comunaRegion?.comunas.forEach((item) => {
          comunas.push({ label: item.nomComuna, value: item.codigoSAP })
        });
        setOptionsComunaRegion([{ label: "Selecione una opción", value: 0 }, ...comunas])
      } else {
        setError(true);
        state.comunaRegion?.message ? setErrorMsg(state.comunaRegion?.message) : setErrorMsg(decode_utf8(props.text_fetch_error))
      }
    }
  }, [state.comunaRegion])

  React.useEffect(() => {
    if (state.allTypelectrodependientes) {
      setLoading(false);
      if (state.allTypelectrodependientes.code === 0) {
        let allTypes = []
        state.allTypelectrodependientes?.dtos.forEach((item) => {
          allTypes.push({ label: item.texto, value: item.valor })
        });
        setOptionsTypeEquipments([...optionsTypeEquipments, ...allTypes])
      } else {
        setError(true);
        state.allTypelectrodependientes?.message ? setErrorMsg(state.allTypelectrodependientes?.message) : setErrorMsg(decode_utf8(props.text_fetch_error))
      }
    }
  }, [state.allTypelectrodependientes])

  React.useEffect(() => {
    if (error) {
      props.setGlobalAlert(errorMsg, "warning", true, "Advertencia");
      setError(false);
    }
  }, [error])

  return (
    <>
      <div className="form-initial">
        <CGE.Panel
          title={"Consideraciones:"}
          description={
            <>
              <strong>- Los campos marcados con * son obligatorios.</strong>
              <br />
              - Si usted desea gestionar un cambio de domicilio debe ingresar el número del cliente de su vivienda anterior.
            </>
          }
        >
          <CGE.PanelSection
            title={"Identificación del cliente:"}
          >
            <div class="row">
              <div className="col-md-3">
                <CGE.FormsField
                  handleChange={(e) => setValues({ ...values, rutPatient: e.target.value })}
                  idFormElement="rutPatient"
                  mandatoryElement={true}
                  labelName="Rut:"
                  placeholder="Rut(Ej: 12345678-9)"
                  hasError={inputValidate?.empty?.rutPatient || inputValidate?.validated?.rutPatient}
                  msgError={inputValidate?.msg?.rutPatient}
                  value={values.rutPatient}
                  typeElement="input-mask"
                  maxLength="12"
                  beforeMaskedValueChange={beforeMaskedValueChangeRut}
                  formatChars={{
                    9: "[0-9]",
                    k: "[Kk0-9]",
                  }}
                  mask="9.999.999-kk"
                  maskChar={null}
                />
              </div>
              <div className="col-md-12">
                <CGE.DetailClient
                  props={{
                    handleChange: (e) => setValues({ ...values, idClient: e.target.value }),
                    hasError: inputValidate?.empty?.idClient,
                    msgError: inputValidate?.msg?.idClient,
                    idClient: values.idClient,
                    idFormElement: "numberClientId",
                    labelName: "Número de Cliente:",
                    placeholder: "Número de Cliente",
                    mandatoryElement: true,
                    valuePub: values.idClient,
                    labelButton: "Buscar",
                    handleClick: () => { handleClickButtonClient() },
                    sizeButton: "sm",
                    typeButton: "primary",
                    propsLabelInfoContent: propsLabelInfoContent

                  }}
                  propsDetail={{
                    fullNameClient: detailClientJson?.PRIMER_NOMBRE_PERSONA ? `${detailClientJson.PRIMER_NOMBRE_PERSONA} ${detailClientJson.SEGUNDO_NOMBRE_PERSONA} ${detailClientJson.APELLIDO_PERSONA}` : "",
                    comunaClient: detailClientJson?.COMUNA || "",
                    calleClient: detailClientJson?.CALLE || "",
                    nCalleClient: detailClientJson?.NUMERO_CASA || "",
                    dptoBlockClient: `${detailClientJson?.SUPLEMENTO || ""} ${detailClientJson?.PISO || ""}`,
                    ctaCtoClient: detailClientJson?.CTA_CTO
                  }}
                />
              </div>
            </div>
          </CGE.PanelSection>
        </CGE.Panel>
      </div>

      {tabsVisible.length > 0 && (
        <div className="bg-white">
          <nav className="container-table pl-0 pr-0 pt-0">
            <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
              {tabsVisible.includes("seguimientoSolicitud") && (
                <li className="nav-item">
                  <a onClick={() => setCurrentPage("seguimientoSolicitud")} className={`nav-link ${currentPage === "seguimientoSolicitud" ? "active" : ""}`} id="seguimiento-solicitud" role="tab" aria-selected={currentPage === "seguimientoSolicitud"}>
                    Seguimiento de solicitud
                  </a>
                </li>
              )}
              {tabsVisible.includes("ingresoSolicitud") && (
                <li className="nav-item">
                  <a onClick={() => setCurrentPage("ingresoSolicitud")} className={`nav-link ${currentPage === "ingresoSolicitud" ? "active" : ""}`} id="ingreso-solicitud" role="tab" aria-selected={currentPage === "ingresoSolicitud"}>
                    Ingreso de solicitud
                  </a>
                </li>
              )}
              {tabsVisible.includes("renovacionSolicitud") && (
                <li className="nav-item">
                  <a onClick={() => setCurrentPage("renovacionSolicitud")} className={`nav-link ${currentPage === "renovacionSolicitud" ? "active" : ""}`} id="renovacion-solicitud" role="tab" aria-selected={currentPage === "renovacionSolicitud"}>
                    Renovación de solicitud
                  </a>
                </li>
              )}
              {tabsVisible.includes("bajaSolicitud") && (
                <li className="nav-item">
                  <a onClick={() => setCurrentPage("bajaSolicitud")} className={`nav-link ${currentPage === "bajaSolicitud" ? "active" : ""}`} id="baja-solicitud" role="tab" aria-selected={currentPage === "bajaSolicitud"}>
                    Baja de solicitud
                  </a>
                </li>
              )}
              {tabsVisible.includes("cambioDomicilio") && (
                <li className="nav-item">
                  <a onClick={() => setCurrentPage("cambioDomicilio")} className={`nav-link ${currentPage === "cambioDomicilio" ? "active" : ""}`} id="cambio-domicilio" role="tab" aria-selected={currentPage === "cambioDomicilio"}>
                    Cambio de domicilio
                  </a>
                </li>
              )}
            </ul>
          </nav>
          <div className="tab-content" id="myTabContent">
            {currentPage === "seguimientoSolicitud" && <SeguimientoSolicitud props={{ ...props, state, error, setError, errorMsg, setErrorMsg, optionsComuna, setOptionsComuna, optionsTypeEquipments, setOptionsTypeEquipments, idClient, setIdClient, optionsComunaRegion, setOptionsComunaRegion, setIdRegion, idRegion, optionsRegion, setOptionsRegion, detailClientJson, loading, setLoading, setJsonForm, resetForm, setResetForm, setDetailClientJson, estado, setEstado, nroSolicitud, setNroSolicitud, fechaIngresoSolicitud, setFechaIngresoSolicitud }} />}
            {currentPage === "ingresoSolicitud" && <FormsElectrodependent
              props={{ ...props, state, error, setError, errorMsg, setErrorMsg, optionsComuna, setOptionsComuna, optionsTypeEquipments, setOptionsTypeEquipments, idClient, setIdClient, optionsComunaRegion, setOptionsComunaRegion, setIdRegion, idRegion, optionsRegion, setOptionsRegion, detailClientJson, loading, setLoading, setJsonForm, resetForm, setResetForm, setDetailClientJson }}
            />}
            {currentPage === "renovacionSolicitud" && <RenovacionSolicitud props={{ ...props, state, error, setError, errorMsg, setErrorMsg, optionsComuna, setOptionsComuna, optionsTypeEquipments, setOptionsTypeEquipments, idClient, setIdClient, optionsComunaRegion, setOptionsComunaRegion, setIdRegion, idRegion, optionsRegion, setOptionsRegion, detailClientJson, loading, setLoading, setJsonFormRe, resetForm, setResetForm, setDetailClientJson, detailSolcitudJson, setDetailSolcitudJson, equiposED, setEquiposED }}
            />}
            {currentPage === "bajaSolicitud" && <BajaSolicitud props={{ ...props, state, error, setError, errorMsg, setErrorMsg, optionsComuna, setOptionsComuna, optionsTypeEquipments, setOptionsTypeEquipments, idClient, setIdClient, optionsComunaRegion, setOptionsComunaRegion, setIdRegion, idRegion, optionsRegion, setOptionsRegion, detailClientJson, loading, setLoading, setJsonFormBa, resetForm, setResetForm, setDetailClientJson, detailSolcitudJson, setDetailSolcitudJson }}
            />}
            {currentPage === "cambioDomicilio" && <CambioDomicilio props={{ ...props, state, error, setError, errorMsg, setErrorMsg, optionsComuna, setOptionsComuna, optionsTypeEquipments, setOptionsTypeEquipments, idClient, setIdClient, optionsComunaRegion, setOptionsComunaRegion, setIdRegion, idRegion, optionsRegion, setOptionsRegion, detailClientJson, loading, setLoading, setJsonFormCd, resetForm, setResetForm, setDetailClientJson, detailSolcitudJson, setDetailSolcitudJson }}
            />}
          </div>
        </div>
      )}
      {loading && <Loading />}
      {visibleModal && (
        <AlertModal
          titleModal="Confirmación"
          observer={observer}
          onClose={onClose}
          status="success"
        >
          <WebContentResponseForms props={{ ...props, webContentResponse }} />
        </AlertModal>
      )}
    </>

  )
}

const FormsElectrodependentControllerWithProvider = ({
  props
}) => (
  <ElectrodependentContextProvider>
    <FormsElectrodependentController
      props={props}
    />
  </ElectrodependentContextProvider>
)
export default FormsElectrodependentControllerWithProvider; 